const styles = {
  container: { 
    padding: "30px", 
    minHeight: "100vh", 
    backgroundColor: "#f4f6f9",
    transition: "margin-left 0.3s ease"
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  formContainer: {
    maxWidth: 900, 
    margin: '0 auto', 
    backgroundColor: '#fff', 
    padding: 25, 
    borderRadius: 12, 
    boxShadow: '0 0 8px rgba(0,0,0,0.1)'
  },
  formTitle: {
    color: '#1B019B', 
    display: 'flex', 
    alignItems: 'center', 
    gap: '10px'
  },
  formRow: {
    display: 'flex', 
    gap: 15, 
    flexWrap: 'wrap',
    marginTop: 15
  },
  formGroup: {
    flex: 1
  },
  formControl: {
    width: '100%'
  },
  defaultConfigLabel: {
    display: "flex", 
    alignItems: "center", 
    cursor: "pointer", 
    fontSize: "15px",
    fontWeight: "500"
  },
  defaultConfigHelp: {
    fontSize: "13px", 
    color: "#555", 
    marginLeft: 28, 
    marginTop: 6, 
    lineHeight: "1.4",
    fontStyle: "italic",
    background: "#f3f7f9",
    padding: "8px 12px",
    borderRadius: "8px",
    borderLeft: "3px solid #4CAF50",
    maxWidth: 450,
    transition: "background 0.3s",
  },
  submitButton: {
    padding: '8px 20px', 
    fontWeight: '600', 
    fontSize: 17, 
    backgroundColor: '#1B019B'
  },
  configListContainer: {
    maxWidth: 1000, 
    margin: '40px auto 60px', 
    backgroundColor: '#fff', 
    padding: 25, 
    borderRadius: 12, 
    boxShadow: '0 0 8px rgba(0,0,0,0.1)'
  },
  configListTitle: {
    textAlign: 'center', 
    color: '#1B019B', 
    marginBottom: 20, 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    gap: '10px'
  },
  tableHeader: {
    backgroundColor: '#1B019B', 
    color: '#fff'
  },
  modalOverlay: {
    backgroundColor: 'rgba(0,0,0,0.6)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1050
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '90%',
    maxHeight: '80%',
    overflowY: 'auto'
  }
};

export default styles;